import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import type { Menu } from '@/interfaces/strapi';
import { menuMapper } from '@/mappers';
import { loadAbort, queryBuilder } from '@/utils';
import { queryParams } from './queryParams';

export const getMenuStrapi = (): UseApiCall<Menu> => {
	const controller = loadAbort();
	const url = queryBuilder(queryParams, '/main-menu');
	return {
		call: strapiInstance.get<Menu>(url, {
			signal: controller.signal,
			transformResponse: [(data: string) => menuMapper(JSON.parse(data).data)],
		}),
		controller,
	};
};
